var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu3Green({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 20.168H19.25",
    stroke: "#58F2F0",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13331 7.67969H3.66667C3.1625 7.67969 2.75 8.09219 2.75 8.59635V16.498C2.75 17.0022 3.1625 17.4147 3.66667 17.4147H5.13331C5.63748 17.4147 6.04998 17.0022 6.04998 16.498V8.59635C6.04998 8.09219 5.63748 7.67969 5.13331 7.67969Z",
    stroke: "#58F2F0",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.731 4.75391H10.2643C9.76016 4.75391 9.34766 5.16641 9.34766 5.67057V16.4964C9.34766 17.0006 9.76016 17.4131 10.2643 17.4131H11.731C12.2351 17.4131 12.6476 17.0006 12.6476 16.4964V5.67057C12.6476 5.16641 12.2351 4.75391 11.731 4.75391Z",
    stroke: "#58F2F0",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3325 1.83203H16.8659C16.3617 1.83203 15.9492 2.24453 15.9492 2.7487V16.4987C15.9492 17.0029 16.3617 17.4154 16.8659 17.4154H18.3325C18.8367 17.4154 19.2492 17.0029 19.2492 16.4987V2.7487C19.2492 2.24453 18.8367 1.83203 18.3325 1.83203Z",
    stroke: "#58F2F0",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu3Green);
export default __webpack_public_path__ + "static/media/Menu3Green.512df3bc9467e63a8631112e75d0082b.svg";
export { ForwardRef as ReactComponent };